import React, { Component } from "react";
import "./../../../public/scss/feedComponent.scss";
import "react-image-lightbox/style.css"; // This only needs to be imported once in your app
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faTimes } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Button,
  Container,
  Row,
  Media,
  Col,
  Card,
  CardTitle,
  CardSubtitle,
  CardBody,
  CardText,
  CardLink,
  Badge,
  Spinner,
  // NavLink
} from "reactstrap";
import yTubeIcon from "./../../../public/images/youtubeIcon.svg";
import moment from "moment";
import { getTesstParameter } from "../../../actions/feedActions";
import emptyUserImg2 from "../../../public/images/empty.svg";

class ScoresAutoPopulatedFeedComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      studentInfo: this.props.studentInfo,
      studentProgarms: this.props.studentProgarms,
      topicVideos: this.props.topicVideos,
      programRelatedData: this.props.programRelatedData,
      randomImages: this.props.randomImages,
      topicWorkSheets: this.props.topicWorkSheets,
      showWorksheets: this.props.showWorksheets,
      randomImageState: false,
      showMoreVideos: false,
      isShowWorkSheet: false,
    };
  }

  componentWillReceiveProps(nextProps, thisProps) {
    if (nextProps.studentInfo) {
      this.setState({
        studentInfo: nextProps.studentInfo,
      });
    }
    if (nextProps.studentProgarms) {
      this.setState({
        studentProgarms: nextProps.studentProgarms,
      });
    }
    if (nextProps.topicVideos) {
      this.setState({
        topicVideos: nextProps.topicVideos,
      });
    }
    if (nextProps.programRelatedData) {
      this.setState({
        programRelatedData: nextProps.programRelatedData,
      });
    }
    if (nextProps.randomImages) {
      this.setState({
        randomImages: nextProps.randomImages,
      });
    }
    if (nextProps.topicWorkSheets) {
      this.setState({
        topicWorkSheets: nextProps.topicWorkSheets,
      });
    }
  }
  showWorksheetsSpec = (index) => {
    var temp_array = this.state.showWorksheets;
    temp_array[index] = !temp_array[index];
    this.setState({
      showWorksheets: temp_array,
    });
  };

  componentDidMount() {}

  formatDate(date) {
    var newDate = date.split("-");
    newDate = newDate[2] + "/" + newDate[1] + "/" + newDate[0];

    return newDate;
  }

  createStars = (length, dynamicColor) => {
    let stars = [];

    // Outer loop to create parent
    for (let i = 0; i < length; i++) {
      let star = <FontAwesomeIcon className={"star star" + (i + 1)} key={i} icon={faStar} size="3x" color={"#fff"} style={{ backgroundColor: dynamicColor }} />;

      stars.push(star);
    }
    return stars;
  };

  redirectToTest = (testId, chapterId, programId, studentId) => {
    debugger;
    getTesstParameter(testId, studentId)
      .then((res) => {
        window.open(
          `https://dashboard.lincolnmethod.com/signin?continue_session=true&student_id=${studentId}&program=${programId}&test_taken=${res.data}&testid=${testId}&assessid=${chapterId}&practice=0&txt_program=${programId}`,
          "_blank"
        );
        debugger;
      })
      .catch((err) => {});
  };

  render() {
    var feed = this.props.data;
    var key = this.props.key2;
    var randomImages = this.state.randomImages;
    var position = this.props.position;
    var dateTime = null;
    try {
      var timeStamp = feed.ts;
      var splittedTimeStamp = timeStamp.split(" ");
      dateTime = this.formatDate(splittedTimeStamp[0]);
    } catch (e) {
      console.log(e);
    }

    var randomImage;
    var imgLength;
    var imgIndex;
    var randomImage;
    var starsLength = 0;

    try {
      if (position == "right") {
        if (feed.score <= 20) {
          // inadequate
          starsLength = 1;
        } else if (feed.score <= 40) {
          // marginal
          starsLength = 2;
        } else if (feed.score <= 60) {
          // adequate
          starsLength = 3;
        } else if (feed.score <= 80) {
          // good
          starsLength = 4;
        } else if (feed.score <= 100) {
          // excellent
          starsLength = 5;
        }
      } else {
        if (feed.score <= 20) {
          starsLength = 1;
        } else if (feed.score <= 40) {
          starsLength = 2;
        } else if (feed.score <= 60) {
          starsLength = 3;
        } else if (feed.score <= 80) {
          starsLength = 4;
        } else if (feed.score <= 100) {
          starsLength = 5;
        }
      }
    } catch (e) {
      console.log(e);
    }

    console.log("IDSTUDETS", this.props.studentInfo);

    const currentTimeZone = moment.tz.guess();

    return (
      <Card
        id={"currentpost" + key}
        style={{
          marginBottom: "2vh",
          border: "1px #ccc solid",
          textAlign: "left",
        }}
      >
        <CardBody>
          <CardTitle>
            <div className="d-flex tutorImageSection">
              <div>
                <img className="mt-1" src={feed.image !== null ? `https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${feed.image}` : emptyUserImg2} width="40" height="40" />
              </div>
              <div className="ml-2">
                <label>
                  {feed.user_name} took a <strong> test </strong>
                </label>{" "}
                <br />
                <span className="gradeName text-primary truncate">
                  {" "}
                  <span style={{ fontSize: 13 }}>Topic:</span> {feed.testname}
                </span>
                <span style={{ fontSize: 10 }}>{moment.tz(feed.ts, "Asia/Karachi").tz(currentTimeZone).fromNow()}</span>
              </div>
            </div>
            {/* <h5>
              <strong>{feed.user_name && feed.user_name}</strong> took a test{" "}
              <strong>{feed.testname}</strong>
            </h5> */}
          </CardTitle>
          <CardSubtitle>
            {/* <Row>
                        <Col> */}

            <div className="d-flex justify-content-between">
              <div>
                {feed.prog_name && feed.prog_name != null ? (
                  <p style={{ fontSize: "12px", color: "#000", margin: 0 }}>
                    Program: <span style={{ fontWeight: "bold" }}>{feed.prog_name}</span>
                  </p>
                ) : null}
                {feed.chapter && feed.chapter != null ? (
                  <p style={{ fontSize: "12px", color: "#000", margin: 0 }}>
                    Chapter: <span style={{ fontWeight: "bold" }}>{feed.chapter}</span>
                  </p>
                ) : null}
              </div>

              <button onClick={() => this.redirectToTest(feed.test_id, feed.assessmentid, feed.prog_id, this.props.studentInfo.id)} className="btn btn-sm" style={{ background: "#D7E7F7" }}>
                Start Quiz
              </button>
              {/* </a> */}
            </div>
            {/* </Col>
                    </Row> */}
          </CardSubtitle>
        </CardBody>

        <CardBody style={{ padding: 0 }}>
          <Row style={{ margin: 0 }}>
            <Col
              className="autoPopulatedPost"
              style={{
                backgroundImage: "url(http://lincolnmethod.s3.us-east-1.amazonaws.com/randomFeedImages/" + feed.image_name + ")",
              }}
            >
              <Row>
                <Col
                  xs={{
                    size: 6,
                    offset: this.props.position == "left" ? 6 : 0,
                  }}
                >
                  <div className={this.props.position == "left" ? "details left" : "details right"}>
                    <div className="ratings">{this.createStars(starsLength, this.props.position == "left" ? "#56e60d" : "#ff0300")}</div>

                    <h3>
                      {this.props.position == "right" ? feed.score : feed.score}
                      <span style={{ fontSize: "20px" }}>%</span>
                    </h3>
                    <h5 style={{ fontSize: "12px" }}>
                      ({this.props.position == "right" ? "1st attempt " : "Improved "}
                      test score)
                    </h5>
                    <h5 style={{ fontSize: "12px" }}>Topic: {feed.testname}</h5>
                    <hr />
                    {feed.correct ? (
                      this.props.position == "right" ? (
                        <p>Correct answers: {feed.correct}</p>
                      ) : (
                        <p>
                          Correct answers:{" "}
                          {
                            // calculating after correct answers
                            parseInt((parseInt(feed.score) / 100) * (feed.correct + feed.incorrect))
                          }
                        </p>
                      )
                    ) : null}
                    {feed.incorrect ? (
                      this.props.position == "right" ? (
                        <p>Incorrect answers: {feed.incorrect}</p>
                      ) : (
                        <p>
                          Incorrect answers:{" "}
                          {
                            // calculating after inCorrect answers
                            parseInt(feed.correct + feed.incorrect - (parseInt(feed.score) / 100) * (feed.correct + feed.incorrect))
                          }
                        </p>
                      )
                    ) : null}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(ScoresAutoPopulatedFeedComponent);
